import gql from 'graphql-tag'

const statsAgentePieCharts = gql`
  query statsAgentePieCharts($agenteId: Int!) {
    statsAgentePieCharts(agenteId: $agenteId) {
      votiForm {
        nome
        valore
      }
      votiAppuntamento {
        nome
        valore
      }
    }
  }
`

export default statsAgentePieCharts


// WEBPACK FOOTER //
// ./src/graphql/queries/statsAgentePieCharts.js